import AlbumSlideshowViewerActions from './AlbumSlideshowViewerActions';

export default AlbumSlideshowViewerActions;
